import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiDialog-paper": {
      minHeight: "94vh",
      maxHeight: "98vh",
      minWidth: "98%",
      maxWidth: "90%",
    },
    "& + .pac-container": {
      zIndex: theme.zIndex.modal + 1
    },
    "& .MuiDialogTitle-root": {
      backgroundColor: theme.palette.custom.main,
      color: "#fff",
      padding: "8px 20px",
    },
    "& .MuiDialogTitle-root+.MuiDialogContent-root ": {
      paddingTop: 20,
    },
    "& .MuiDialogContent-root": {
      padding: "20px 20px",
    },
    "& .MuiDialogActions-root": {
      paddingInlineEnd: 24,
    },
  },
  chevronbutton:{
    position: "absolute !important",
    top:75,
    zIndex: 2,
    background: "#fff !important",
    borderRadius: "50% !important",
    transition: "left 0.3s ease-in-out !important",
    "& .MuiSvgIcon-root":{
      fontSize: '2rem !important',
      fontWeight: 100,
    }
  },
  driverdlistbox:{
    width: 350, background: "#fff", borderRadius: 2, 
    overflowY : "scroll !important",
    boxShadow: 3,
    height:"80%",
    position:"absolute",
    top: 100,
  },

}));

export default useStyles;
